/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RemarketingInputs */

const cs_enum_remarketing = /** @type {(inputs: Enum_RemarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarketing`)
};

const en_enum_remarketing = /** @type {(inputs: Enum_RemarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarketing`)
};

/**
* | output |
* | --- |
* | "Remarketing" |
*
* @param {Enum_RemarketingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_remarketing = /** @type {((inputs?: Enum_RemarketingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RemarketingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_remarketing(inputs)
	return cs_enum_remarketing(inputs)
});